import { forwardRef, useId } from "react";
import type { InputHTMLAttributes } from "react";

import { cn } from "./utils";

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  etiqueta: string;
  ayuda?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { etiqueta, ayuda, className, id, ...resto },
  ref,
) {
  const idGenerado = useId();
  const idCampo = id ?? idGenerado;
  const idAyuda = ayuda ? `${idCampo}-ayuda` : undefined;

  return (
    <div className={cn("flex flex-col", className)}>
      <label htmlFor={idCampo} className="flex min-h-control cursor-pointer items-center gap-3 text-cuerpo text-texto">
        <input
          ref={ref}
          id={idCampo}
          type="checkbox"
          aria-describedby={idAyuda}
          className="h-6 w-6 shrink-0 cursor-pointer rounded-control border border-borde accent-primario focus-visible:shadow-foco disabled:cursor-not-allowed"
          {...resto}
        />
        <span>{etiqueta}</span>
      </label>
      {ayuda ? (
        <p id={idAyuda} className="text-nota text-texto-secundario">
          {ayuda}
        </p>
      ) : null}
    </div>
  );
});
